module.exports = __webpack_public_path__ + "img/customer_service.84dd15ab.png";